import { render, staticRenderFns } from "./classical-dashboard.vue?vue&type=template&id=c855aa72&scoped=true"
import script from "./classical-dashboard.vue?vue&type=script&lang=js"
export * from "./classical-dashboard.vue?vue&type=script&lang=js"
import style0 from "./classical-dashboard.vue?vue&type=style&index=0&id=c855aa72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c855aa72",
  null
  
)

export default component.exports